import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var _context, _context2; var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(source), !0)).call(_context, function (key) { _defineProperty(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }

import _URLSearchParams from "@babel/runtime-corejs3/core-js-stable/url-search-params";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import Page from "orion/lib/page";
import Loader from "orion/lib/loader";
import { AlertsContext } from "../contexts/alertsContext";
import AlertsList from "../components/alertsList";
import { fetchAlertsList, setFilters } from "../actionCreators/alertsListActionCreators";
import { fetchAlertsTypeOptions } from "../actionCreators/alertsSettingActionCreators";
import { alertsListSelector } from "../selectors/alertsListSelector";
import { toUnderscoreCase } from "../helpers/appHelper";
import { useDruvaAlerts } from "../contexts/DruvaAlertsContext";

var RealizeAlertsContainer = function RealizeAlertsContainer(props) {
  var _useLocation = useLocation(),
      search = _useLocation.search;

  var params = new _URLSearchParams(search);
  var severity = params.get("severity");
  var alerts = props.alerts,
      alertsCount = props.alertsCount,
      isLoading = props.isLoading,
      nextPageToken = props.nextPageToken,
      sortBy = props.sortBy,
      sortOrder = props.sortOrder,
      filters = props.filters,
      loadingMore = props.loadingMore,
      isFirstLoad = props.isFirstLoad,
      fetchAlertsList = props.fetchAlertsList,
      setFilters = props.setFilters,
      fetchAlertsTypeOptions = props.fetchAlertsTypeOptions;

  var _useDruvaAlerts = useDruvaAlerts(),
      _useDruvaAlerts$apiCo = _useDruvaAlerts.apiConfig,
      alertsApiPath = _useDruvaAlerts$apiCo.alertsApiPath,
      accessTokenApiPath = _useDruvaAlerts$apiCo.accessTokenApiPath,
      alertsApiBaseUrl = _useDruvaAlerts$apiCo.alertsApiBaseUrl,
      isMsp = _useDruvaAlerts.isMsp;

  useEffect(function () {
    var filterParam = {};
    var alertTypeName = filters.alertTypeName,
        alertSeverity = filters.alertSeverity;

    if (alertTypeName) {
      filterParam = _defineProperty({}, toUnderscoreCase("alertTypeName"), alertTypeName.value);
    }

    if (alertSeverity) {
      //Check if alertSeverity is an Option and its value is not all
      if (alertSeverity.value !== "All") {
        filterParam = _objectSpread(_objectSpread({}, filterParam), {}, _defineProperty({}, toUnderscoreCase("alertSeverity"), alertSeverity.value));
      }
    } // On navigation to alerts page, alertSeverity will be undefined but
    // by default we have to select Critical or use severity from
    // searchparams.
    else if (alertSeverity !== "") {
      var defaultSeverity = severity ? severity.charAt(0).toUpperCase() + _sliceInstanceProperty(severity).call(severity, 1).toLowerCase() : isMsp ? "All" : "Critical";

      if (defaultSeverity !== "All") {
        filterParam = _objectSpread(_objectSpread({}, filterParam), {}, _defineProperty({}, toUnderscoreCase("alertSeverity"), defaultSeverity));
      }
    }

    fetchAlertsList("", toUnderscoreCase(sortBy), sortOrder, filterParam, alertsApiBaseUrl, alertsApiPath, accessTokenApiPath);
  }, [sortBy, sortOrder, filters]);
  useEffect(function () {
    fetchAlertsTypeOptions({
      apiBaseUrl: alertsApiBaseUrl,
      apipathprefix: alertsApiPath,
      accessTokenApiPath: accessTokenApiPath
    });
    return function () {
      setFilters({});
    };
  }, []);
  return /*#__PURE__*/React.createElement(Page.Main, null, /*#__PURE__*/React.createElement(Page.Header, null, /*#__PURE__*/React.createElement(Page.Title, null, /*#__PURE__*/React.createElement(Page.TitleText, null, "Alerts"))), /*#__PURE__*/React.createElement(Page.Body, null, /*#__PURE__*/React.createElement(Loader, {
    isLoading: isLoading,
    fullPage: true
  }), /*#__PURE__*/React.createElement(AlertsContext.Provider, {
    value: {
      alerts: alerts,
      alertsCount: alertsCount,
      isLoading: isLoading,
      nextPageToken: nextPageToken,
      sortBy: sortBy,
      sortOrder: sortOrder,
      filters: filters,
      loadingMore: loadingMore,
      isFirstLoad: isFirstLoad
    }
  }, /*#__PURE__*/React.createElement(AlertsList, null))));
};

var mapStateToProps = function mapStateToProps(state) {
  return alertsListSelector(state);
};

var mapDispatchToProps = {
  fetchAlertsList: fetchAlertsList,
  setFilters: setFilters,
  fetchAlertsTypeOptions: fetchAlertsTypeOptions
};
export default connect(mapStateToProps, mapDispatchToProps)(RealizeAlertsContainer);